// This file was automatically generated from app.settings.staffGroups.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.settings.staffGroups');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffGroups.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h1 class="el8PageTitle">User Groups</h1><div class="staff-group-section"><div><div class="el8InlineBlock w36 mr5 el8StrongMiniHeading padv10">Group Name</div><div class="el8InlineBlock w13 mr5 el8StrongMiniHeading padv10">Members</div></div><ul class="staff-group-list el8SettingsTable el8Loading ebs-list-unstyled"></ul><button class="add-trigger ebs-btn ebs-btn-default">+ Add User Group</button></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffGroups.list = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var groupList7478 = opt_data.staffGroups;
  var groupListLen7478 = groupList7478.length;
  for (var groupIndex7478 = 0; groupIndex7478 < groupListLen7478; groupIndex7478++) {
    var groupData7478 = groupList7478[groupIndex7478];
    output.append('<li class="curated-list-item el8SettingsTableRow" data-id="', soy.$$escapeHtml(groupData7478.id), '"><div class="w35 el8SettingsTableCell"><p class="pad10 el8Bold el8Ellipsis">', soy.$$escapeHtml(groupData7478.name), '</p></div><div class="w50 el8SettingsTableCell"><p class="pad10">');
    var sList7484 = groupData7478.users;
    var sListLen7484 = sList7484.length;
    for (var sIndex7484 = 0; sIndex7484 < sListLen7484; sIndex7484++) {
      var sData7484 = sList7484[sIndex7484];
      output.append(soy.$$escapeHtml(sData7484.fullName), (! (sIndex7484 == sListLen7484 - 1)) ? '; ' : '');
    }
    output.append('</p></div><div class="w15 el8SettingsTableCell">', (! groupData7478.isElationGroup) ? '<div class="pad10"><a class="edit-trigger el8Link">edit</a><a class="remove-trigger el8Link ml10">remove</a></div>' : '', '</div></li>');
  }
  output.append('<li class="new-form-stub"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffGroups.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<form><li class="el8SettingsTableRow"><div class="w30 el8SettingsTableCell"><div class="pad10"><input type="text" class="el8EditorTextareaWrap ebs-form-control" name="name" /></div></div><div class="w70 el8SettingsTableCell"><div class="pad10"><ul class="group-member-list ebs-list-unstyled mb0"></ul><input type="text" class="ebs-form-control" name="users" /></div></div></li><div class="el8InlineBlock form-buttons"></div></form>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.settings.staffGroups.groupMemberList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.staff) {
    var sList7502 = opt_data.staff;
    var sListLen7502 = sList7502.length;
    if (sListLen7502 > 0) {
      for (var sIndex7502 = 0; sIndex7502 < sListLen7502; sIndex7502++) {
        var sData7502 = sList7502[sIndex7502];
        output.append('<div class="el8UserListItem"><p class="el8LargerText">', soy.$$escapeHtml(sData7502.fullName), '<a class="remove-member-trigger el8StandardFontSize ml10" data-id="', soy.$$escapeHtml(sData7502.id), '">Remove</a></p></div>');
      }
    } else {
      output.append('<div class="el8UserListItem"><p class="el8LargerText el8GreyText"><i>This group is empty.</i></p></div>');
    }
  }
  if (!opt_sb) return output.toString();
};
